var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"timeline",staticClass:"timeline",on:{"scroll":_vm.onTimelineScroll}},[(_vm.duration)?_c('div',{staticClass:"line"},_vm._l((_vm.blocks),function(block,index){return _c('div',{key:index,staticClass:"block",style:('width:' + block.width + 'px;')},[_c('span',[_vm._v(_vm._s(block.label))])])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }